function initPromoSliders ($reinit) {
    $('.b-main-slider').each(function() {
        var $context = $(this),
            $slider = $('.b-main-slider__slider', $context);

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var next = $('[data-slick-index="'+nextSlide+'"');
            if(next.hasClass('is-on-black')) {
                $('.b-page').addClass('is-on-black');
                $('.b-page').removeClass('is-on-white');
            } else if(next.hasClass('is-on-white')) {
                $('.b-page').addClass('is-on-white');
                $('.b-page').removeClass('is-on-black');
            }
        });

        $slider.on("init", function(){
            if($('.slick-active').hasClass('is-on-black')) {
                $('.b-page').addClass('is-on-black');
                $('.b-page').removeClass('is-on-white');
            } else if($('.slick-active').hasClass('is-on-white')) {
                $('.b-page').addClass('is-on-white');
                $('.b-page').removeClass('is-on-black');
            }
        });

        $slider.slick({
            dots: false,
            fade: true,
            prevArrow: $('.b-main-slider__arrow-prev'),
            nextArrow: $('.b-main-slider__arrow-next')
        })
    });
}
$(function () {
    initPromoSliders();
});
